import React from 'react';

export const GridViewIcon = ({ nameOfClass }: { nameOfClass?: string }) => (
    <svg className={nameOfClass} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M4 4h7v7H4V4zm9 0h7v7h-7V4zM4 13h7v7H4v-7zm9 0h7v7h-7v-7z" />
    </svg>
);
